import initDatepicker from "./datepicker";

function appendOption(parent, text, value) {
    const element = document.createElement('option');
    element.appendChild(document.createTextNode(text));
    element.value = value;
    parent.appendChild(element);
}

function clearOptions(element) {
    let i, L = element.options.length - 1;
    for (i = L; i >= 0; i--) {
        if (element.options[i].value !== 'none') {
            element.remove(i);
        }
    }
}

let currentWorkoutGroups = {};

export default function initWorkoutsModal(e) {
    const modal = document.getElementById('workout-reservation');

    if (modal) {
        const dateSelect = modal.querySelector('.workout-date-select');
        const procedureSelect = modal.querySelector('.workout-procedure-select');
        const procedureSelectLoader = procedureSelect.parentNode.querySelector('.from__static-loader');
        const coachSelect = modal.querySelector('.workout-coach-select');
        const timeSelect = modal.querySelector('.workout-time-select');
        const reserveButton = modal.querySelector('.to-cart-btn');

        dateSelect.addEventListener('change', async () => {
            clearOptions(procedureSelect);
            clearOptions(coachSelect);
            clearOptions(timeSelect);

            procedureSelect.setAttribute('disabled', 'true');
            reserveButton.setAttribute('disabled', 'true');
            timeSelect.setAttribute('disabled', 'true');
            procedureSelectLoader.classList.remove('d-none');
            procedureSelect.style.color = 'transparent';

            try {
                let response = await axios.get('/wp-json/api/get-workouts?date=' + dateSelect.value  + '&rest_language=' + document.documentElement.lang.split('-')[0]);

                procedureSelect.removeAttribute('disabled');
                procedureSelectLoader.classList.add('d-none');
                procedureSelect.style.color = '';

                if (response.data) {
                    currentWorkoutGroups = response.data;

                    for (let i = 0, keys = Object.keys(response.data), ii = keys.length; i < ii; i++) {
                        const items = response.data[keys[i]];
                        const title = items[0]['procedure_descr'];

                        // const start = item['begins'].split(' ')[1];
                        // const startText = start.split(':')[0] + ':' + start.split(':')[1];
                        //
                        // const end = item['ends'].split(' ')[1];
                        // const endText = end.split(':')[0] + ':' + end.split(':')[1];

                        appendOption(procedureSelect, title, keys[i]);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        });

        procedureSelect.addEventListener('change', () => {
            reserveButton.setAttribute('disabled', 'true');
            coachSelect.removeAttribute('disabled');
            clearOptions(coachSelect);
            clearOptions(timeSelect);

            let items = currentWorkoutGroups[procedureSelect.value];
            let uniqueItems = {};

            for (let i = 0, keys = Object.keys(items), ii = keys.length; i < ii; i++) {
                const item = items[keys[i]];
                uniqueItems[item['trainer_id']] = item;
            }

            for (let i = 0, keys = Object.keys(uniqueItems), ii = keys.length; i < ii; i++) {
                const item = uniqueItems[keys[i]];
                appendOption(coachSelect, item['trainer_id'], item['trainer_id']);
            }
        });

        coachSelect.addEventListener('change', () => {
            reserveButton.setAttribute('disabled', 'true');
            clearOptions(timeSelect);
            timeSelect.removeAttribute('disabled');
            let items = currentWorkoutGroups[procedureSelect.value];

            for (let i = 0, keys = Object.keys(items), ii = keys.length; i < ii; i++) {
                const item = items[keys[i]];

                if (item['trainer_id'] === parseInt(coachSelect.value)) {
                    const start = item['begins'].split(' ')[1];
                    const startText = start.split(':')[0] + ':' + start.split(':')[1];
                    const end = item['ends_real'].split(' ')[1];
                    const endText = end.split(':')[0] + ':' + end.split(':')[1];
                    appendOption(timeSelect, startText + ' - ' + endText, item['begins'] + '_' + item['ends']);
                }
            }
        });

        timeSelect.addEventListener('change', () => {
            reserveButton.removeAttribute('disabled');
        });
    }
}
